export const CampaignObjectiveEnum = {
  "BUDGET" : 0,
  "REACH": 1,
  "RATING": 2,
  "PLACED": 3,
};

export const dayWeekList = [
  {id: 0, name: 'Monday'},
  {id: 1, name: 'Tuesday'},
  {id: 2, name: 'Wednesday'},
  {id: 3, name: 'Thursday'},
  {id: 4, name: 'Friday'},
  {id: 5, name: 'Saturday'},
  {id: 6, name: 'Sunday'},
];

export const defaultDayWeekRows = [{
  id: 0,
  startDayId: null,
  endDayId: null,
  allocation: 0,
  exclude: false,
},];

export const defaultDayPartRow = {
  id: 1,
  daypartId: null,
  allocation: 0,
  startTime: null,
  endTime: null,
  exclude: false,
  customDayRange: null,
  startDayId: null,
  endDayId: null,
  customDaypartName: '',
};

export const includeFieldRows = [
  {
    name: 'applyExcludeAvails',
    label: 'Apply excluded programs filter during import',
  },
  {
    name: 'applyIncludeAvails',
    label: 'Apply included programs filter during import',
  },
  {
    name: 'applyCampaignDates',
    label: 'Apply campaign flight date during import',
  },
  {
    name: 'applyAssignedSpots',
    label: 'Upload assigned spots per program during import',
  },
];


export const daysList = [
  { id: 1, name: 'M-F', startDayId: 1, endDayId: 5 },
  { id: 2, name: 'Sa', startDayId: 6, endDayId: 6 },
  { id: 3, name: 'Su', startDayId: 7, endDayId: 7 },
  { id: 4, name: 'Sa-Su', startDayId: 6, endDayId: 7 },
];

// DropdownList Type
export const ExcludeFieldType = {
  "RATINGS": 0,
  "UNIT_PRICE": 1,
  "CPP": 2,
}

export const DropdownListType = {
  "TOP_RATED": 0,
  "GREATER_THAN": 1,
  "LESS_THAN": 2,
  "BOTTOM_RATED": 3,
}

export const CampaignType= [
  { id: 1, name: 'TV'},
  { id: 2, name: 'Radio' },
];

export const marketScopeSwitchOptions = [
  { id: 1, label: 'Agency' },
  { id: 2, label: 'Client' },
];

// Exclude Avails Dropdownlist Options
export const ExcludesDropdownLists = {
  exclude1: [
    { id: DropdownListType.GREATER_THAN, name: 'Ratings greater than' },
    { id: DropdownListType.TOP_RATED, name: 'Top rated(%)' },
  ],
  exclude2: [
    { id: DropdownListType.LESS_THAN, name: 'Ratings less than' },
    { id: DropdownListType.BOTTOM_RATED, name: 'Bottom rated(%)' },
  ],
  exclude3: [
    { id: DropdownListType.GREATER_THAN, name: 'Unit price greater than' },
    { id: DropdownListType.TOP_RATED, name: 'Top rated(%) unit price' },
  ],
  exclude4: [
    { id: DropdownListType.LESS_THAN, name: 'Unit price less than' },
    { id: DropdownListType.BOTTOM_RATED, name: 'Bottom rated (%) unit price' },
  ],
  exclude5: [
    { id: DropdownListType.GREATER_THAN, name: 'CPP greater than' },
    { id: DropdownListType.TOP_RATED, name: 'Top rated(%) CPP' },
  ],
  exclude6: [
    { id: DropdownListType.LESS_THAN, name: 'CPP less than' },
    { id: DropdownListType.BOTTOM_RATED, name: 'Bottom rated (%) CPP' },
  ],
};

export const defaultAvailsExcludes = [
  ExcludesDropdownLists.exclude1[0],
  ExcludesDropdownLists.exclude2[0],
  ExcludesDropdownLists.exclude3[0],
  ExcludesDropdownLists.exclude4[0],
  ExcludesDropdownLists.exclude5[0],
  ExcludesDropdownLists.exclude6[0],
];
